import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { CcParamsUserDetailsWebsiteComponent } from "@app/cc-params-user-details-website/cc-params-user-details-website.component"
import { RouterLink } from "@angular/router"

@Component({
	selector: "app-cc-params-self-coordination",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenButtonGroupComponent,
		GenInputComponent,
		CcParamsUserDetailsWebsiteComponent,
		RouterLink,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<h4 class="gen-title section-title">
				{{ "self_coordination" | langVal }}
			</h4>
			@if (!permsService?.owner_has_users) {
				<div class="row">
					<div class="col-4 col-md-2">
						<label>{{ "meeting_request_with_calendar" | langVal }}</label>
						<app-gen-button-group
							[actualObj]="configcliniq"
							fieldName="meeting_request_with_calendar"
							optionsListName="yes_no_opts"
							(changeEvent)="validateAndSave()"
						/>
					</div>
					<div class="col-4 col-md-2">
						<button
							class="btn btn-primary"
							style="margin-top: 25px"
							titleLang="time_allocation"
							tabindex="-1"
							routerLink="/time-allocation/"
						>
							{{ "time_allocation" | langVal }}
						</button>
					</div>
					<div class="col-4 col-md-2">
						<label>{{ "guest_sched_hours_to_add" | langVal }}</label>
						<app-gen-input
							tabindex="64"
							[actualObj]="configcliniq"
							[errors]="errors"
							fieldName="guest_sched_hours_to_add"
							(keyupEvent)="validateAndSave()"
						/>
					</div>
				</div>
			}
			@if (apiLink) {
				<div class="row">
					<div class="col-12">
						<button
							class="btn btn-primary"
							(click)="copyApiLink()"
							titleLang="copy_link"
						>
							{{ "copy_external_link" | langVal }}
						</button>
					</div>
				</div>
			} @else {
				{{ "meetingtypes_and_time_allocation_shoud_be_defined" | langVal }}
			}
			<hr class="separation-line" />
			<app-cc-params-user-details-website></app-cc-params-user-details-website>
		</div>
	`,
})
export class CcParamsSelfCoordinationComponent extends CcParamsGen {
	//inheriting most functions and fields!
	saveObjName: string = "self-coordination" //which part to save while updating
	apiLink: string = ""
	only_therapist_id: number = 0

	async ngOnInit() {
		this.getApiKeys()
		this.only_therapist_id = this.store.cc()?.only_therapist_id
	}
	async getApiKeys() {
		if (!this.permsService.owner_has_users && !this.only_therapist_id) {
			const meetingtypes = this.store.getSiteDataTable("meetingtypes")
			if (
				!meetingtypes.find((mt) => mt?.first_time_meeting_request == "yes") &&
				!meetingtypes.find((mt) => mt?.return_meeting_request == "yes")
			) {
				return
			}
		}
		this.apiLink = await this.store.getApiLink("guest-sched")
	}

	async copyApiLink() {
		navigator.clipboard.writeText(this.apiLink)
		this.modalService.openToast("copy_link")
		//window.open(this.apiLink, "_blank")
	}
}
